import React from 'react';
import {
    Paper,
    Typography,
    Checkbox
} from 'material-ui';
import { withStyles } from 'material-ui/styles';
import { translate } from 'react-i18next';
import { Grid } from 'material-ui';
import { FormControlLabel } from 'material-ui';
import { FormGroup } from 'material-ui';

class ObservationsChecksRender extends React.Component {

    constructor(props) {
        super(props);

        this.state = { observations: '' };
    }


    render() {
        const { t, checks, viewOnlyMode } = this.props;
        return (
            <div>
                <div>
                    {viewOnlyMode ?
                        <Grid item xs={12} style={{ display: 'flex', flexWrap: 'wrap' }}>
                            {checks.map((check, idx) => (
                                check.checked &&
                                <Grid item xs={4} style={{ display: 'flex', alignItems: 'center' }} key={idx}>
                                    <FormGroup row>
                                        <FormControlLabel
                                            control={
                                                <Checkbox value={check.value} onChange={event => {
                                                    if (this.props.onCheckboxChange) {
                                                        this.props.onCheckboxChange(check.value, event.target.value);
                                                    }
                                                }}
                                                    checked={check.checked}
                                                    disabled={viewOnlyMode}
                                                    name="checkedCM" />
                                            }
                                            label={t(check.label)}>
                                            {/* <Typography>{t(check.label)}</Typography> */}
                                        </FormControlLabel>
                                    </FormGroup>
                                </Grid>
                            ))}
                        </Grid> :
                        <Grid item xs={12} style={{ display: 'flex', flexWrap: 'wrap' }}>
                            {checks.map((check, idx) => (                             
                                <Grid item xs={4} style={{ display: 'flex', alignItems: 'center' }} key={idx}>
                                    <FormGroup row>
                                        <FormControlLabel
                                            control={
                                                <Checkbox value={check.value} onChange={event => {
                                                    if (this.props.onCheckboxChange) {
                                                        this.props.onCheckboxChange(check.value, event.target.value);
                                                    }
                                                }}
                                                    checked={check.checked}
                                                    disabled={viewOnlyMode}
                                                    name="checkedCM" />
                                            }
                                            label={t(check.label)}>
                                            {/* <Typography>{t(check.label)}</Typography> */}
                                        </FormControlLabel>
                                    </FormGroup>
                                </Grid>
                            ))}
                        </Grid>
                    }
                </div>
            </div >
        );
    }
}

export default translate('translations')(ObservationsChecksRender);


// WEBPACK FOOTER //
// ./src/components/Reservation/ObservationsChecksRender.js